import { Card, Container, CardHeader, Divider, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import Page from 'src/components/Page';
import {  getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));



function VideoHelper() {
  const classes = useStyles();
  const SessionUser = getUser();
  useEffect(() => {
    var VideoCallUser = SessionUser.ServiceShopCode +'-' + SessionUser.NameSurname;
    var Link = process.env.REACT_APP_REMOTE_HELP_URL + "?UserId=" + VideoCallUser;
    window.open(Link);
  }, [SessionUser]);

 



  return (
    <Page className={classes.root} title="Görüntülü Destek">
      <Container maxWidth="lg">
        <Card>
          <CardHeader title="Görüntülü Destek" /> 
          <Divider />
          <CardContent>
            Görüntü Destek Sistemine Bağlanıyorsunuz!..... 
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default VideoHelper;
